export const addNote = (note) => ({
    type: 'ADD_NOTE',
    payload: note
});

export const setFilter = (filter) => ({
    type: 'SET_FILTER',
    payload: filter
});

